export default "__VITE_ASSET__BAmB5UeF__"